import { useState } from "react";
import { Pagination } from "antd";
import { StatusRow } from "./StatusRow";

const ITEMS_PER_PAGE = 10;

export const StatusTable = ({ servicios, reglas }) => {
  const [currentPage, setCurrentPage] = useState(1);

  if (!servicios || servicios.length === 0) {
    return <div className="semaforo-dinamico__empty">Sin servicios</div>;
  }

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const serviciosPaginados = servicios.slice(startIndex, endIndex);
  const totalPages = Math.ceil(servicios.length / ITEMS_PER_PAGE);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div>
      <div className="semaforo-dinamico__table-wrapper">
        <table className="semaforo-dinamico__table">
          <thead>
            <tr>
              <th className="semaforo-dinamico__th">ID</th>
              <th className="semaforo-dinamico__th">Siniestro</th>
              <th className="semaforo-dinamico__th">Tiempo</th>
              <th className="semaforo-dinamico__th">Urgencia</th>
            </tr>
          </thead>
          <tbody>
            {serviciosPaginados.map((servicio) => (
              <StatusRow key={servicio.id} servicio={servicio} reglas={reglas} />
            ))}
          </tbody>
        </table>
      </div>

      {servicios.length > ITEMS_PER_PAGE && (
        <div className="semaforo-dinamico__pagination">
          <Pagination
            current={currentPage}
            total={servicios.length}
            pageSize={ITEMS_PER_PAGE}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
};
